
import { GamesRounded, ShowChartRounded } from '@material-ui/icons'
import './styles.css'

const icons = {
    game: <GamesRounded />,
    line_chart: <ShowChartRounded />
}

export default function IconWithText({ config }) {
    const Icon = (props) => icons[config.icon]

    return (
        <div className='icon-with-text' style={{ ...(config.style || {}) }}>
            <span style={{ color: config.iconColor || 'white' }}><Icon /></span>
            <p>{config.text}</p>
        </div>
    )
}